import { useEffect } from "react";

/* Redirects an old on-site route to an external address (e.g. the ERP jobs portal).
   Server-side 301s (frontend/nginx.conf in prod, the preview server locally) handle direct
   loads and SEO. This component handles IN-APP link clicks, which navigate client-side and
   never reach the server — so every CTA that still points at the old path lands on the portal. */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "grid",
        placeItems: "center",
        textAlign: "center",
        padding: "40px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        color: "#1E2D38",
      }}
    >
      <p>
        Redirecting to <a href={to} style={{ color: "#C45E20" }}>{to.replace(/^https?:\/\//, "")}</a>…
      </p>
    </div>
  );
}
